import styled from 'styled-components'

export const ExternalLinkBase = styled.a`
  text-decoration: underline;
`
